class ShowMainBlockDetail {
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.detailBlock = this.el.querySelector(".js-main-block-detail");
        this.btn = this.el.querySelector(".js-show-main-block-detail");

        this.bindEventListeners();
    }
    
    /**
     * Прослушивание событий.
     * 
     * @returns {void}
     */
    bindEventListeners() {
        this.btn?.addEventListener("click", (e) => {
            e.preventDefault();
            this.showDetailBlock();
        });
    }

    /**
     * Раскрытие текста.
     * 
     * @returns {void}
     */
    showDetailBlock() {
        this.detailBlock.classList.remove("hidden");
        this.btn.classList.add("hidden");
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-main-block")
        .forEach(card => new ShowMainBlockDetail(card));
});